<template>
    <div id="contenedor-seccion-logo-intranet" class="container-fluid">
        <div class="d-flex justify-content-between">
            <!-- LOGO PJ -->
            <div>
                <img id="icono-pj-intranet" @click="irAHome" src="../../../../../assets/logo-pj-transparente-blanco.png" />
            </div>
            <!-- INFORMACION USUARIO -->
            <div class="d-flex justify-content-end align-items-center">
                <!-- AVATAR -->
                <div id="contenedor-avatar-usuario">
                    <h5>{{ obtenerInicialesDeUsuario }}</h5>
                </div>
                <!-- DATOS DE USUARIO -->
                <div id="datos-usuario">
                    <span id="nombre-usuario">{{ obtenerNombreCompleto }} </span>
                    <br>
                     <span id="area-usuario">{{ obtenerNombreDeArea }}</span> 
                </div>
                 
                 <!-- ACCIONES EXTRA -->
                <div id="acciones-extra" class="form-inline justify-content-end">
                    <div class="contenedor-accion">
                    <router-link   title="Regresa al tablero de sistemas" to="/Tablero/SistemasWeb">
                     <i class="fas fa-th-large text-white" ></i>
                    </router-link>
                   </div>
                 <!-- <div class="contenedor-accion" @mouseover="mostrarAyuda = true" @mouseleave="mostrarAyuda = false">
                        <i class="fas fa-question-circle"></i>                     
                        <div class="listado-de-ayuda" v-if="mostrarAyuda == true">
                            <ul>
                                <li v-for="ayuda in listadoDeAyuda" :key="ayuda.Nombre">
                                <a v-on:click="AbrirDocumento(ayuda.Ruta)" class=""><i class="fas fa-file-download"></i>&nbsp;&nbsp;&nbsp;{{ayuda.Nombre}}</a>
                                </li>
                            </ul>
                        </div>
                 </div> -->

                    <div class="contenedor-accion" v-on:click="cerrarSesion">
                        <i class="fas fa-sign-out-alt"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import router from '@/router/index'
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            mostrarAyuda:false,
            usuarioDatos: {
                nombreCompleto: 'Informática está probando',
                area: 'Dirección de informática'
            }
        }
    },
    methods: {
        irAHome: function() {
            router.push({ name: "Inicio" });
        },
        AbrirDocumento: function(vinculo, formaDeApertura = "_self") {
        window.open(vinculo, formaDeApertura);
      },
      validarQueLaSesionSigaActiva: function() {
        if(this.$store.state.TiempoDeVerificacionId != null)
          clearInterval(this.$store.state.TiempoDeVerificacionId);

        this.$store.state.Login_TiempoDeVerificacionId = setInterval(async () => {
            this.recargarDatosDeLaSesion()
          }, 600000);
      },
      recargarDatosDeLaSesion: async function() {
        const parametros = {
          CargaInformacionDePaginaActual: true
        }

        await this.A_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema(parametros);
      },
        cerrarSesion: function() {
        const parametrosDeConfirmacion = {
          mensaje: "Esta a punto de cerrar sesión.<br />¿Desea finalizar su sesión?",
          textoDeCancelacion: "Cancelar",
          textoDeConfirmacion: "Cerrar sesión",
          nombreDeFuncionSi: "this.cerrarSesion",
          datosSi: null,
          nombreDeFuncionNo: null,
          datosNo: null
        };

        this.A_ConfirmacionParaCerrarSesion(parametrosDeConfirmacion);
      },

    ...mapActions([
        'A_ConfirmacionParaCerrarSesion',
        'A_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema'
      ])
    },
    computed: {
        obtenerInicialesDeUsuario() {
            // agregar logica para obtener las inicilaes del nomber del usuario
            return   this.$store.state.Login_Usuario.Iniciales;
        },
        obtenerNombreCompleto(){
            return this.$store.state.Login_Usuario.TituloYNombreCompleto;
        },
        obtenerNombreDeArea(){
            if(this.$store.state.Login_Usuario.Area != null)
             return this.$store.state.Login_Usuario.Area.Nombre;
         },
         listadoDeAyuda() {
         return this.$store.state.Login_ListadoDeAyuda;
       },


        // obtenerUsuario(){
        //        return this.$store.state.Login_Usuario;
        // }

    },
    mounted() {
         this.validarQueLaSesionSigaActiva();
    },
}
</script>
<style scoped>
#contenedor-seccion-logo-intranet {
    background-color: #000000;
    height: 10vmin;
    color: #FFFFFF;
    padding: 10px 40px 10px 20px;
}

#icono-pj-intranet {
    width: 10vmin;
    height: 7vmin;
    color: #be9a5e;
    cursor: pointer;
}

#contenedor-avatar-usuario {
    background-color: #5a5858;
    width: 6vmin;
    height: 6vmin;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    padding-top: 1vh;
    margin-right: 10px;
}

#contenedor-avatar-usuario h5 {
    font-size: 3.5vmin;
    font-weight: bold;
}

#nombre-usuario {
    font-weight: bold;
    font-size: 2vmin;
}

#area-usuario {
    font-size: 1.8vmin;
    color: #b6b6b6;
}

#datos-usuario br {
    display: block; 
    content: ""; 
    margin-top: -6px; 
}

#acciones-extra {
    margin-left: 3em;
}

.contenedor-accion {
    padding: 2vmin 1vmin 2vmin 1vmin;
    cursor: pointer;
}

.contenedor-accion:hover, .contenedor-accion:focus {
    background-color: rgb(68, 68, 68);
}

.contenedor-accion i {
    font-size: 3.5vmin;
}


  .listado-de-ayuda {
    position: fixed;
    top: 60px;
    right: 0;
    background-color: #45454c;
    min-width: 150px;
  }

    .listado-de-ayuda ul {
      margin: 0 0 0 0;
      padding: 0;
    }

      .listado-de-ayuda ul li {
        padding: 10px;
        list-style: none;
        cursor: pointer;
      }

      .listado-de-ayuda ul li:hover {
        background-color: #333333;
      }

        .listado-de-ayuda ul li a {
          text-decoration: none;
          color: white;
        }



</style>


// WEBPACK FOOTER //
// src/components/Intranet/Comun/Estructura/Header/CSeccionLogoUsuario.vue